<template>
  <div style="
      
        position:absolute;
        left:0;top:0;bottom:0;right:0;overflow-y:scroll;
      margin-left:1rem;margin-top:2rem">
    <v-container >
        <v-form 
            ref="form"
            v-model="validForm"
            lazy-validation
        >
        <v-layout 
            row wrap
            elevation-1
            class="telemetry-container" 
            style="
                padding-left:1rem;
                padding-right:1rem;
                margin-bottom:1rem"
        >
            <v-flex xs12 sm12 md12>
                <v-combobox
                    v-model="selectedDevices"
                    label="Select devices"
                    :items="devices"
                    item-value="id"
                    item-text="attributes.customName"
                    multiple
                    chips
                    return-object
                    :rules="selectedDeviceRules"
                    required
                >
                <template v-slot:selection="data">
                    <v-chip
                    :key="JSON.stringify(data.item)"
                    :selected="data.selected"
                    :disabled="data.disabled"
                    class="v-chip--select-multi"
                    @input="data.parent.selectItem(data.item)"
                    >
                    <v-avatar
                        class="accent" 
                    ><v-icon color="#EEEEEE" dark>memory</v-icon></v-avatar>
                    {{ data.item.attributes.customName }}
                    </v-chip>
                </template>
                </v-combobox>
            </v-flex>
        </v-layout>
        <v-layout 
            row wrap 
            elevation-1 white 
            class="telemetry-container">
            <v-container>
                <v-layout  row wrap justify-space-around align-center>
                    
                    <v-flex xs12 sm6 md3>
                        <v-select
                            prepend-icon="date_range"
                            v-model="selectedWindowTime"
                            label="Select window time"
                            :items="windowTimes"
                            item-value="id"
                            item-text="label"
                            return-object
                            :rules="windowTimeRules"
                            required
                        ></v-select>
                    </v-flex>
                    <!-- <v-flex xs12 sm6 md2>
                        <v-text-field
                            prepend-icon="access_time"
                            label="Start time"
                            v-bind:value="
                                (selectedStartTime.timeObj)?
                                    selectedStartTime.timeObj.toLocaleTimeString()+' - '+
                                    selectedStartTime.timeObj.toLocaleDateString()
                                :''
                            "
                            :disabled="(selectedWindowTime)?selectedWindowTime.id!=-1:true"
                            v-on:click="openDataPicker=true;selectedTime=selectedStartTime"
                            :rules="selectedTimeRules"
                            required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                        <v-text-field
                            prepend-icon="access_time"
                            label="End time"                          
                            v-bind:value="
                                (selectedEndTime.timeObj)?
                                    selectedEndTime.timeObj.toLocaleTimeString()+' - '+
                                    selectedEndTime.timeObj.toLocaleDateString()
                                :''
                            "
                            :disabled="(selectedWindowTime)?selectedWindowTime.id!=-1:true"
                            v-on:click="openDataPicker=true;selectedTime=selectedEndTime"
                            :rules="selectedTimeRules"
                            required
                        ></v-text-field>
                    </v-flex >   -->

                    <v-flex xs12 sm6 md2>
                        <v-text-field
                            prepend-icon="access_time"
                            label="Start time"
                            v-bind:value="
                                (selectedStartTime.timeObj)?
                                    selectedStartTime.timeObj.toLocaleTimeString()+' - '+
                                    selectedStartTime.timeObj.toLocaleDateString()
                                :''
                            "
                            :disabled="(selectedWindowTime)?selectedWindowTime.id!=-1:true"
                            v-on:click="openDataPicker=true;selectedTime=selectedStartTime;timeOffset=0"
                            :rules="selectedTimeRules"
                            required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                        <v-text-field
                            prepend-icon="access_time"
                            label="End time"                          
                            v-bind:value="
                                (selectedEndTime.timeObj)?
                                    selectedEndTime.timeObj.toLocaleTimeString()+' - '+
                                    selectedEndTime.timeObj.toLocaleDateString()
                                :''
                            "
                            :disabled="(selectedWindowTime)?selectedWindowTime.id!=-1:true"
                            v-on:click="openDataPicker=true;selectedTime=selectedEndTime;timeOffset=86399999"
                            :rules="selectedTimeRules"
                            required
                        ></v-text-field>
                    </v-flex> 
                    
                    <v-flex xs6 sm3 md1>
                        <v-btn class="blue" icon dark v-on:click="submit">
                            <v-icon>play_arrow</v-icon>
                        </v-btn>
                    </v-flex>
                    <!-- <v-dialog
                        ref="dialog"
                        v-model="openDataPicker"
                        persistent
                        lazy
                        full-width
                        width="290px"
                    >
                        <v-time-picker
                            v-model="selectedTime.time"
                            full-width
                        >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="openDataPicker = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="openDataPicker=false">OK</v-btn>
                        </v-time-picker>
                    </v-dialog> -->
                    <v-dialog
                        ref="dialog"
                        v-model="openDataPicker"
                        persistent
                        lazy
                        full-width
                        width="550px"
                    >
                        <!-- <v-time-picker
                            v-model="selectedTime.time"
                            full-width
                        >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="openDataPicker = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="openDataPicker=false">OK</v-btn>
                        </v-time-picker> -->
                        <!-- <v-date-picker
                        ref="picker"
                        v-model="selectedTime.time"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        ></v-date-picker>
                        <v-btn flat color="primary" @click="openDataPicker = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="openDataPicker=false">OK</v-btn> -->

                        <div class="white">
                            <v-date-picker
                                color="#39a9dc"
                                ref="picker"
                                v-model="selectedTime.time"
                                min="1950-01-01"
                                style=";padding:1rem;padding-bottom:0"
                                width="17.5rem"
                            ></v-date-picker>
                            <v-time-picker 
                                color="#39a9dc"
                                v-model="selectedTime.timeHour" 
                                format="24hr"
                                style="padding:1rem;padding-bottom:1.85rem"
                                width="17.5rem"
                                height="15.5rem"

                            ></v-time-picker>
                            
                            <v-btn flat color="#002052" @click="openDataPicker = false"><v-icon small style="margin-right:0.5rem">close</v-icon>Cancel</v-btn>
                            <v-btn color="#FFD300"  @click="openDataPicker=false"><v-icon small style="margin-right:0.5rem">send</v-icon>OK</v-btn>
                        </div>
                    </v-dialog>
                </v-layout>
            </v-container>
        </v-layout>
        </v-form>
        <v-layout 
            row wrap white 
            elevation-1 
            style="margin-top:2rem;padding:1rem"
            class="telemetry-container"
            >
            <v-flex xs12 sm12 md12>
                <v-timeline
                    align-top
                    dense
                >
                    <v-timeline-item
                        :color="event.color" small
                        v-for="(event,index) in computedEvents"
                        :key="index"
                    >
                        <EventView :event="event"></EventView>
                    </v-timeline-item>
                </v-timeline>
            </v-flex>
        </v-layout>
    </v-container>

    <v-snackbar
        :timeout="0"
        :value="telemetryRealtime"
        :bottom="true"
        :right="true"
    >
        <v-progress-circular
            width="1.7"
            style="width:1.2rem;"
            indeterminate
            color="green"
        ></v-progress-circular>
      <span style="font-weight:bold">Listening events</span>
        <v-btn icon dark v-on:click="stopRealtimeTelemetry">
            <v-icon>pause</v-icon>
        </v-btn>
    </v-snackbar>

    <inprogress  :dialog="operationInProcess" :message="operationInProcessMessage" ></inprogress>
  </div>
</template>

<script>
    import { mapState } from 'vuex'
    import EventView from '@/components/EventView'


    export default {

        name: "Events",
        
        components:{
            "EventView": EventView
        },

        data: function(){
            return {
                colors: [
                    '#f67019',
                    '#f53794',
                    '#537bc4',
                    '#acc236',
                    '#166a8f',
                    '#00a950',
                    '#58595b',
                    '#8549ba',
                    '#4dc9f6'
                ],
                validForm: false,
                selectedTimeRules: [
                    v => !!v || 'Time constrain required'
                ],
                windowTimeRules:[
                    v=> !!v || 'Window time required'
                ],
                selectedDeviceRules:[
                    v=> !!v || 'Select at least one device',
                    v => v.length>0 || 'Select at least one device'
                ],

                telemetryChartModel:{},

                selectedDevices : [],
                selectedMeasure: null,
                openDataPicker: false,
                selectedWindowTime: null,
                selectedTime:{},
                selectedEndTime:{
                    timeObj:null,
                    time:new Date().toISOString().substr(0, 10),
                    timeHour:"23:59"
                },
                selectedStartTime:{
                    timeObj:null,
                    time: new Date().toISOString().substr(0, 10),
                    timeHour:"00:00"
                }, 
                windowTimes:[
                    {
                        id:1,
                        label:"Last 1h"
                    },
                    {
                        id:3,
                        label:"3h"
                    },
                    {
                        id:6,
                        label:"6h"
                    },
                    {
                        id:-1,
                        label:"Custom"
                    }

                ],

                computedEvents: []
            }
        },

        computed:{
            ...mapState(
                {
                    devices: state => state.devices.devices.filter(device=>device.configurationSignaled.measures!=null&&device.configurationSignaled.measures!=undefined),
                    events: state => state.telemetry.events ,
                    telemetryRealtime: state => state.telemetry.listeningRelatime,
                    operationInProcess:'operationInProcess',
                    operationInProcessMessage: 'operationInProcessMessage'
                }
            )

        },

        watch:{
            selectedWindowTime(){
                this.buildWindowTime()
            },
            'selectedTime.time':function(){
                if(this.selectedTime.time&&this.selectedTime.time!=""){

                    // this.selectedTime.timeObj = new Date(Date.parse(this.selectedTime.time)+this.timeOffset)

                    let ch = this.selectedTime.timeHour.split(":")
                    let hh = parseInt(ch[0])
                    let mm = parseInt(ch[1])
                    this.selectedTime.timeObj = new Date(Date.parse(this.selectedTime.time)+ hh*60*60*1000 + mm*60*1000)

                    // this.selectedTime.timeObj = new Date()
                    // let hhmm= this.selectedTime.time.split(':')
                    // this.selectedTime.timeObj.setHours(parseInt(hhmm[0]))
                    // this.selectedTime.timeObj.setMinutes(parseInt(hhmm[1]))             
                    // this.selectedTime.timeObj.setSeconds(0)        
                }
            },
            'selectedTime.timeHour':function(){
                if(this.selectedTime.time&&this.selectedTime.timeHour!=""){
                    let ch = this.selectedTime.timeHour.split(":")
                    let hh = parseInt(ch[0])
                    let mm = parseInt(ch[1])
                    this.selectedTime.timeObj = new Date(Date.parse(this.selectedTime.time)+ hh*60*60*1000 + mm*60*1000)      
                }
            },
            events:{
                handler(){
                    this.buildEventsData()
                },
                deep: true
            },

            selectedDevices: function(){
                this.buildEventsData()
            },
        },

        async destroyed(){
            await 
                this
                .$store
                .dispatch('telemetry/stopTelemetryRealtime')
        },

        methods:{
            submit: async function(){
                this.validForm = this.$refs.form.validate()
                if (this.validForm) 
                {
                    if(this.telemetryRealtime)
                        await 
                            this
                            .$store
                            .dispatch('telemetry/stopEventsRealtime')

                    this.buildWindowTime()
                    await 
                        this
                        .$store
                        .dispatch(
                            (this.selectedWindowTime.id==0)?
                                'telemetry/startEventsRealtime':
                                'telemetry/fetchEvents',
                            {
                                devices:this.selectedDevices,
                                startTime:this.selectedStartTime.timeObj,
                                endTime:this.selectedEndTime.timeObj
                            }
                        )
                    return 
                }
            },

            stopRealtimeTelemetry: async function(){
                await 
                    this
                    .$store
                    .dispatch('telemetry/stopTelemetryRealtime')
            },

            buildWindowTime(){
                let hours = this.selectedWindowTime.id
                switch(hours){
                    case 0:
                        this.selectedStartTime.timeObj = new Date()
                        this.selectedEndTime.timeObj = new Date()
                        break
                    case -1:
                        break
                    case null:
                        break
                    case undefined:
                        break
                    default:
                        this.selectedEndTime.timeObj = new Date()
                        this.selectedStartTime.timeObj = new Date(this.selectedEndTime.timeObj.getTime()-hours*60*60*1000)
                        return
                }
            },

            buildEventsData(){
                let events = this.events.filter(event => this.selectedDevices.find(selectedDevice => selectedDevice.id==event.id));
                let i = 0;
                
                // [{ id: "deviceid", data: [] }, .. ]
                events.forEach( deviceEvents =>
                    {   let deviceId = deviceEvents.id
                        this.computedEvents = this.computedEvents.concat(deviceEvents.data.map(
                            (deviceEvent) => {
                                let computedEvent = {
                                    id : deviceId,
                                    color: this.colors[i%this.events.length]
                                };
                                for(let j in deviceEvent)
                                    computedEvent[j] = deviceEvent[j];
                                return computedEvent;
                            }
                        ));
                        i++;
                    }
                );
                
                this.computedEvents = this.computedEvents.sort((e1,e2)=>e1.timestamp.getTime()>e2.timestamp.getTime());
            }
        }
    }
</script>